import OnlineOrderValuesModel from "../../services/models/formModels/onlineOrderValues.model";

export function isSccAllLowRisk(
  values: Partial<OnlineOrderValuesModel>
): boolean {
  if (Number(values.testTypeId) !== 2) {
    return false;
  }

  const history = values.historyPhysicalExam;
  const pathology = values.pathologySurgicalFindings;

  if (!history || !pathology) {
    return false;
  }

  return (
    history.isPatientImmunocompromised === "No" &&
    history.isTumorLocatedOnHeadOrNeck === "No" &&
    history.tumorDiameter === "<2 cm" &&
    pathology.isPerineuralInvolvement === "No" &&
    pathology.isPoorlyDifferentiated === "No"
  );
}

export function isSccIntegratedTestBlocked(
  values: Partial<OnlineOrderValuesModel>
): boolean {
  if (!isSccAllLowRisk(values)) {
    return false;
  }

  const history = values.historyPhysicalExam;
  const pathology = values.pathologySurgicalFindings;
  const hasAdditionalHistory =
    (history?.additionalHistoryPhysicalExam?.length ?? 0) > 0;
  const hasAdditionalPathology =
    (pathology?.additionalPathologySurgicalFindings?.length ?? 0) > 0;

  return !hasAdditionalHistory && !hasAdditionalPathology;
}
